import { render } from "./TreatmentDetailPage.vue?vue&type=template&id=d31dc4f0&scoped=true"
import script from "./TreatmentDetailPage.vue?vue&type=script&lang=js"
export * from "./TreatmentDetailPage.vue?vue&type=script&lang=js"

import "./TreatmentDetailPage.vue?vue&type=style&index=0&id=d31dc4f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31dc4f0"]])

export default __exports__